export const meta = {
  id: 'v3-subtle',
  label: 'v3 — Subtle confident',
  hint: 'Send-ready. No meta-narration of the meeting.',
  date: '2026-05-06',
  status: 'final' as const,
  audience: 'public' as const,
  notes: 'Drops the agenda + closing apologetics. Lets the deck just act like an intro.',
};
